import getCurrentUrl from "./getCurrentUrl";

export default () =>
  [...getCurrentUrl().searchParams].reduce((params, [key, value]) => {
    params[key] = value;

    return params;
  }, {});
